import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=3753afbf&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=3753afbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3753afbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3753afbf')) {
      api.createRecord('3753afbf', component.options)
    } else {
      api.reload('3753afbf', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=3753afbf&scoped=true&", function () {
      api.rerender('3753afbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/UserForm.vue"
export default component.exports